module.exports = __webpack_public_path__ + "media/images/athletes/1998-2a74d2b57e8eed285eb2b9a738fa5afa.png";